import { render, staticRenderFns } from "./UiDropdown.vue?vue&type=template&id=eb6d6250&"
import script from "./UiDropdown.vue?vue&type=script&lang=ts&"
export * from "./UiDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports